import ApplicationController from "./application_controller";
import StimulusReflex from "stimulus_reflex";
import interact from "interactjs";

/* good article: https://javascript.info/mouse-drag-and-drop */
export default class extends ApplicationController {
  static targets = ["column"];

  connect() {
    super.connect();
    StimulusReflex.register(this);

    this.boardsstimulusController =
      document.querySelector("#board-workspace").boardsstimulus;

    interact('li.post-item [draggable="true"]').draggable({
      listeners: {
        start: this.dragCardStart.bind(this),
        move: this.dragCard.bind(this),
      },
    });

    interact("li.post-item").dropzone({
      ondrop: function (event) {
        console.log("ondrop: event: " + JSON.stringify(this.dragCoordinates));
        let dropTargetCard = this.cardAtDragPosition();
        if (dropTargetCard == undefined) {
          console.log(`card was dropped on self or no card found`);
        } else {
          console.log(
            this.dragItem.id + " was dropped on " + dropTargetCard.id,
          );

          this.stimulateDropOnCard(event, dropTargetCard);
        }

        this.dragCardEnd(event);
      }.bind(this),
    });

    interact(".board-column").dropzone({
      ondrop: function (event) {
        event.stopPropagation();
        event.preventDefault();

        this.stimulateDropOnColumn(event, event.target);
        this.dragCardEnd(event);
      }.bind(this),
    });

    this.altModifierKeyPressed = false;

    document.addEventListener(
      "keydown",
      function (event) {
        if (event.keyCode == 18) {
          this.altModifierKeyPressed = true;
        }
      }.bind(this),
    );
    document.addEventListener(
      "keyup",
      function (event) {
        if (event.keyCode == 18) {
          this.altModifierKeyPressed = false;
        }
      }.bind(this),
    );
  }
  getBoardsStimulusController() {
    return document.querySelector("body").boardsstimulus;
  }

  voidDrag(event) {
    return false;
  }
  dragCardStart(event) {
    event.stopPropagation();
    event.preventDefault();

    // console.log(`dragCardStart: ${JSON.stringify(event.detail)}`);

    this.dragItem = this.getParent(event.target, "cardid", "dataset");

    this.formatDragCard(this.dragItem);

    return true;
  }
  dragCard(event) {
    /*event.stopPropagation();*/
    event.preventDefault();

    if (this.dragItem == undefined) {
      // console.log("this.dragItem is undefined")
      return false;
    }
    /* implement autoscrolling here */
    this.moveDragTwin(event);
    this.highlightCardDragOver(event);
    this.highlightColumnDragOver(event);
  }
  dragCardEnd(event) {
    event.stopPropagation();
    event.preventDefault();
    this.removeFormatDragCard(this.dragItem);
    this.removeFormatDragColumn();
    this.removeAllDragoverHighlights();
    this.dragItem = undefined;
  }
  insertDragTwin(draggedCard) {
    // console.log("create dragTwin with id: " + draggedCard.dataset.cardid);
    if (
      this.dragTwin == undefined ||
      this.dragTwin.dataset.cardid != draggedCard.dataset.cardid
    ) {
      this.dragTwin = draggedCard.cloneNode(true);
    }
    this.dragTwin.style.width =
      draggedCard.getBoundingClientRect().width + "px";
    this.dragTwin.style.position = "absolute";
    draggedCard.insertAdjacentElement("afterend", this.dragTwin);
  }
  formatDragCard(draggedCard) {
    draggedCard.classList.add("opacity-50");
    if (this.dragTwin != undefined) {
      this.insertDragTwin(draggedCard);
    }
  }
  moveDragTwin(event) {
    this.dragCoordinates = this.coordFromEvent(event);

    if (this.dragTwin == undefined) {
      this.insertDragTwin(this.dragItem);
    }

    this.dragTwin.style.left = this.dragCoordinates.pageX - 125 + "px";
    this.dragTwin.style.top = this.dragCoordinates.pageY - 25 + "px";

    let scrollMargin = 50;
    let maxXScroll = document.body.scrollWidth - window.visualViewport.width;
    let ec = this.dragCoordinates;

    // use for debugging
    // let logo = document.querySelector("h1");
    // logo.innerText = `${ec.screenX} / ${ec.screenY} [ < ${m + hsize}] || [> ${window.visualViewport.height - ec.y}]`;

    let column = this.columnAtX(this.dragCoordinates.pageX);
    if (column == undefined) {
      return null;
    }
    let cStartY = column.getBoundingClientRect().y;
    let cEndY = window.visualViewport.height;

    let needsScrollX =
      ec.screenX < scrollMargin ||
      window.visualViewport.width - ec.screenX < scrollMargin;
    let needsScrollYUp = ec.screenY < cStartY + scrollMargin;
    let needsScrollYDown = ec.screenY > cEndY - scrollMargin;
    let scrollTo = [window.scrollX, window.scrollY];

    if (needsScrollX) {
      scrollTo[0] =
        this.dragCoordinates.pageX - window.visualViewport.width / 2;
      if (scrollTo[0] <= 0) {
        scrollTo[0] = 0;
      }
      if (scrollTo[0] >= maxXScroll) {
        scrollTo[0] = maxXScroll;
      }
      window.scrollTo(scrollTo[0], 0);
    }

    if (column && (needsScrollYUp || needsScrollYDown)) {
      let scrollBy = needsScrollYUp ? -10 : 10;
      // console.log(`scrollY to ${0}/${scrollBy}`);
      // also check out: scrollIntoView()
      column.scrollBy(0, scrollBy);
    }
  }
  cardAtDragPosition() {
    let x = this.dragCoordinates.screenX + window.scrollX;
    let col = this.columnAtDragCoordinates(x);
    let y = this.dragCoordinates.screenY;

    var foundTarget = null;
    if (col == undefined) {
      console.log(`no col found at x ${x}`);
      return foundTarget;
    }
    const cards = col.querySelectorAll(".post-item");
    for (const card of cards) {
      let cardYStart = card.getBoundingClientRect().y;
      let cardYEnd = cardYStart + card.getBoundingClientRect().height;

      if (cardYStart <= y && cardYEnd >= y && card.id != this.dragItem.id) {
        foundTarget = card;
      }
    }
    return foundTarget;
  }
  columnAtDragCoordinates() {
    let x = this.dragCoordinates.screenX + window.scrollX;
    return this.columnAtX(x);
  }
  columnAtX(x) {
    let cols = document.querySelectorAll(".column-list-container");
    for (var i = 0; i < cols.length; i++) {
      let c = cols[i];
      let cStart = c.getBoundingClientRect().x + window.scrollX;
      let cEnd = cStart + c.getBoundingClientRect().width;
      // console.log(`looking for col at ${x} - [${cStart} / ${cEnd}]`);
      if (x >= cStart && x <= cEnd) {
        return c;
      }
    }
    return null;
  }
  removeFormatDragCard(draggedCard) {
    if (draggedCard != undefined) {
      draggedCard.style.position = "static";
      draggedCard.classList.remove("opacity-50");
    }
    if (this.dragTwin != undefined) {
      this.dragTwin.remove();
    }
  }

  async stimulateDropOnCard(event, dropOnCard) {
    console.log("stimulateDropOnCard ");
    // Reflex method:
    // receiveDrop(cardTargetId, new_status, cardid, isTopTarget, copy=false)

    // let col = this.getParent(dropOnCard, "board-column").dataset.status;
    let col = dropOnCard.closest(".board-column").dataset.status;
    let currentDropzone = dropOnCard.querySelector(".card-dropzone");

    /*
    if (super.isConnected()) {
      let trgid =
        dropOnCard.dataset != undefined ? dropOnCard.dataset.cardid : 0;

      this.getBoardsStimulusController().stimulate(
        "BoardsReflex#receiveDrop",
        event.target,
        trgid, // dropTargetId
        col,
        this.dragItem.dataset.cardid,
        this.isTopTargetEvent(event, currentDropzone), // isTopTarget
        this.altModifierKeyPressed,
      );
    } else {*/
      // console.log("no stimulateDrop");

      const response = await this.doFetch(
        "/posts/" + this.dragItem.dataset.cardid + "/move",
        "PATCH",
        JSON.stringify({
          authenticity_token: this.getCsrfToken(),
          dropTarget: dropOnCard.dataset.cardid,
          isTopTarget: this.isTopTargetEvent(event, currentDropzone),
          board_column_id: col,
          remote: true,
        }),
      );
      if (response.ok) {
        // location.reload();
        /*
         * use this for further customisation - for now go with reloading the page
        let json_return = await response.json();
        console.log("did move with response: " + JSON.stringify(json_return))
        */
      } else {
        alert("There was an error when trying to move this card!");
      }
  }

  async stimulateDropOnColumn(event, dropOnColumn) {
    // console.log("\n\nstimulateDropOnColumn");
    // Reflex method:
    // receiveDrop(cardTargetId, new_status, cardid, isTopTarget, copy=false)

    let col = dropOnColumn.dataset.status;

    if (super.isConnected()) {
      this.getBoardsStimulusController().stimulate(
        "BoardsReflex#receiveDrop",
        event.target,
        -1, // dropTargetId
        col,
        this.dragItem.dataset.cardid,
        this.isTopColumnEvent(event, dropOnColumn), // isTopTarget
        this.altModifierKeyPressed,
      );
    } else {
      const response = await this.doFetch(
        "/posts/" + this.dragItem.dataset.cardid + "/move",
        "PATCH",
        JSON.stringify({
          authenticity_token: this.getCsrfToken(),
          dropTarget: -1,
          isTopTarget: this.isTopColumnEvent(event, dropOnColumn),
          board_column_id: col,
          remote: true,
        }),
      );
      if (response.ok) {
        location.reload();
        /*
         * use this for further customisation - for now go with reloading the page
        let json_return = await response.json();
        console.log("did move with response: " + JSON.stringify(json_return))
        */
      } else {
        alert("There was an error when trying to move this card!");
      }
    }
  }

  highlightCardDragOver(event) {
    let overCard = this.cardAtDragPosition();

    if (overCard == undefined) {
      this.removeAllDragoverHighlights();
      return false;
    }
    let overColumn = overCard.closest('.board-column');

    if (!overColumn.classList.contains("drop-target")) {
      this.removeAllDragoverHighlights();
      return false;
    }

    let targetDropzone = overCard.querySelector(".card-dropzone");

    // return if no card was found
    if (!targetDropzone) {
      return false;
    }
    return this.cardDragOver(overCard);
  }
  highlightColumnDragOver(event) {
    let columnListContainer = this.columnAtDragCoordinates();
    // console.log("col: ", columnListContainer ? columnListContainer.classList : "col is undefined")
    if (columnListContainer == undefined) {
      console.log("cannot drop on column")
      return false;
    }
    let boardColumn = columnListContainer.closest(".board-column");

    if(boardColumn && !boardColumn.classList.contains("drop-target")) {
      console.log("cannot drop on link column")
      return false;
    }

    if (this.highlightedColumn != undefined && this.highlightedColumn != columnListContainer) {
      this.removeClasses(this.highlightedColumn, ["coldndhighlight"]);
    }
    this.highlightedColumn = columnListContainer;
    this.addClasses(this.highlightedColumn, ["coldndhighlight"]);
  }
  removeFormatDragColumn() {
    // for (var i = 0; i < this.columnTargets.length; i++) {
    if (this.highlightedColumn != undefined) {
      this.removeClasses(this.highlightedColumn, ["coldndhighlight"]);
    }
    // }
  }
  searchValidDropTarget(
    event,
    coord,
    searchAttr = "cardid",
    searchType = "dataset",
  ) {
    event.stopPropagation();
    event.preventDefault();
    let dropTargetElements = document.elementsFromPoint(
      coord.pageX,
      coord.pageY,
    );

    for (var i = 0; i < dropTargetElements.length; i++) {
      let testElement = this.getParent(
        dropTargetElements[i],
        searchAttr,
        searchType,
      );
      if (
        testElement &&
        testElement.dataset.cardid != this.dragItem.dataset.cardid
      ) {
        // console.log(
        //   `did find dropTarget ${testElement.id} at coords ${coord.pageX}/${coord.pageY} attr: ${searchAttr} type: ${searchType}`,
        // );
        return testElement;
      }
    }
    return false;
  }

  removeAllDragoverHighlights() {
    document.querySelectorAll(".card-dropzone").forEach(
      function (cdrz) {
        this.removeClasses(cdrz, ["dragoverbottom", "dragovertop"]);
      }.bind(this),
    );
  }
  cardDragOver(dragTargetCard) {
    // if the drag occured over a new card
    // set this.cardDragOverElement
    if (
      this.cardDragOverElement == undefined ||
      dragTargetCard.id != this.cardDragOverElement.id
    ) {
      if (dragTargetCard.id != this.dragItem.id) {
        this.cardDragOverElement = dragTargetCard;
      }
    }

    this.removeAllDragoverHighlights();

    // Add margin top or bottom depending on event coordinates
    if (this.cardDragOverElement == undefined) {
      return true;
    }
    let currentDropzone =
      this.cardDragOverElement.querySelector(".card-dropzone");
    if (this.isTopTargetEvent(event, currentDropzone)) {
      this.addClasses(currentDropzone, ["dragovertop"]);
    } else {
      this.addClasses(currentDropzone, ["dragoverbottom"]);
    }
  }

  pageDragCoordinates() {
    let scrollX = window.scrollX;
    let scrollY = window.scrollY;
    return [
      this.dragCoordinates.screenX + scrollX,
      this.dragCoordinates.screenY + scrollY,
    ];
  }
  isTopColumnEvent(event, column) {
    let scrollX = window.scrollX;
    let scrollY = window.scrollY;
    let coords = this.pageDragCoordinates();
    let columnRect = column.getBoundingClientRect();
    let columnCards = column.querySelectorAll("li.post-item");

    // console.log(`event coordinates on page: ${coords[0]}/${coords[1]}`);
    // console.log(
    //   `column position ${columnRect.x + scrollX}/${columnRect.y + scrollY} r/bottom: // ${columnRect.right}/${columnRect.bottom}`,
    // );
    // this.isTopTargetEvent(event, column, true);

    // If there are no cards in the column return true
    if (columnCards == undefined || columnCards.length == 0) {
      console.log("no cards found… return false");
      return true;
    }

    let lastCardRect =
      columnCards[columnCards.length - 1].getBoundingClientRect();
    if (coords[1] >= lastCardRect.bottom) {
      return false;
    }
    return true;
  }

  isTopTargetCoords(coords, trg, debug = false) {
    if (trg == undefined || trg === false) {
      return true;
    }

    let trgTop = trg.getBoundingClientRect().top;
    let trgHeight = trg.getBoundingClientRect().height;
    let border = trgTop + trgHeight / 2;

    if (debug) {
      console.log(
        "isTopTargetCoords: event: y:" +
          coords.pageY +
          " trg: y + h : (" +
          trgTop +
          " + " +
          trgHeight +
          ") / 2 = " +
          border,
      );
    }
    return coords.pageY <= border;
  }

  isTopTargetEvent(event, trg, debug = false) {
    return this.isTopTargetCoords(this.coordFromEvent(event), trg, false);
  }

  coordModdedFromEvent(event) {
    if (event.type == "touchmove") {
      var coord = {
        pageX: event.touches[0].pageX - window.scrollX,
        pageY: event.touches[0].pageY - window.scrollY,
      };
    } else {
      var coord = {
        pageX: event.pageX - window.scrollX,
        pageY: event.pageY - window.scrollY,
      };
    }
    return coord;
  }
  // pageX and pageY are relative to viewport
  // screenX and screenY are relative to screen
  coordFromEvent(event) {
    if (event.type.match(/touch/)) {
      return {
        pageX: event.changedTouches[0].pageX,
        pageY: event.changedTouches[0].pageY,
        screenX: event.changedTouches[0].screenX,
        screenY: event.changedTouches[0].screenY,
      };
    }
    if (event.type.match(/drop/)) {
      return this.dragCoordinates;
    }
    return {
      pageX: event.pageX,
      pageY: event.pageY,
      screenX: event.pageX - window.scrollX,
      screenY: event.pageY - window.scrollY,
    };
  }

  /*
   *
   * Touch stuff
   *
   */

  touchMoveCard(event) {
    event.stopPropagation();
    event.preventDefault();

    let draggedCard = this.getParent(event.target, "cardid", "dataset");
    let isTopTarget = this.isTopTargetEvent(event, draggedCard);
    let coord = this.coordFromEvent(event);

    var card_id = draggedCard.dataset["cardid"];

    this.dragItem = draggedCard;
    this.formatDragCard(this.dragItem);
    this.moveDragTwin(event);
    this.highlightCardDragOver(event);
    this.highlightColumnDragOver(event);
    // if (!this.highlightCardDragOver(event)) {
    //   this.highlightColumnDragOver(event);
    // }
  }
}
